module.exports = __webpack_public_path__ + "img/yaoqing.32a0463e.jpg";